export { default } from './ProductDetails';
